import { GuidePageId } from "./guidePages.ts";

/** Where the guide stands: it stays open from one page to the next. */
export type GuideState = {
  readonly open: boolean;
  // the entry that is open, of the page it belongs to
  readonly picked?: { readonly page: GuidePageId; readonly entry: string };
  // the entry whose marker or header is being pointed at
  readonly pointed?: string;
};

export type GuideAction =
  // the button of the page
  | { type: "toggle" }
  // a marker
  | { type: "pick"; page: GuidePageId; entry: string }
  // an entry's own header
  | { type: "toggleEntry"; page: GuidePageId; entry: string }
  // a marker or an entry pointed at, or none any more
  | { type: "point"; entry?: string };

export const guideClosed: GuideState = { open: false };

/** The entry that is open on a page. */
export const pickedEntry = (
  { picked }: GuideState,
  page: GuidePageId,
): string | undefined => (picked?.page === page ? picked.entry : undefined);

export function guideReducer(
  state: GuideState,
  action: GuideAction,
): GuideState {
  switch (action.type) {
    case "toggle":
      return { open: !state.open, picked: state.picked };
    case "pick":
      return {
        ...state,
        open: true,
        picked: { page: action.page, entry: action.entry },
      };
    case "toggleEntry":
      return {
        ...state,
        picked:
          pickedEntry(state, action.page) === action.entry
            ? undefined
            : { page: action.page, entry: action.entry },
      };
    case "point":
      return { ...state, pointed: action.entry };
  }
}
